import React, { Component } from 'react'
import { Pagination } from 'react-bootstrap';

class SimplePaginationLinks extends Component {

  handleOnClickPrev = () => {
    const { pagination } = this.props;
    const page = pagination.current_page > 1 ? pagination.current_page - 1 : 1;

    this.props.onPageChange(page);
  }

  handleOnClickNext = () => {
    const { pagination } = this.props;
    const page = pagination.current_page + 1;

    this.props.onPageChange(page);
  }

  render() {
    const { pagination = {}, size = '', className = '', disabled } = this.props;

    return (
      <Pagination className={ className } size={ size }>
        <Pagination.Prev
          disabled={ !pagination.current_page || pagination.current_page <= 1 || disabled }
          onClick={ this.handleOnClickPrev }
        />
        <Pagination.Next
          disabled={ !pagination.current_page || pagination.per_page > pagination.count || disabled }
          onClick={ this.handleOnClickNext }
        />
      </Pagination>
    )
  }
}

export default SimplePaginationLinks;